import React from 'react';

interface CreateCalendarIconProps {
  isActive?: boolean;
  className?: string;
}

const CreateCalendarIcon: React.FC<CreateCalendarIconProps> = ({ isActive = false, className = 'mr-2' }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    className={className} 
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect 
      width="18" 
      height="18" 
      x="3" 
      y="4" 
      rx="2" 
      ry="2"
      stroke={isActive ? "#4F46E5" : "#4B5563"}
      fill="#EEF2FF"
    />
    <line x1="16" x2="16" y1="2" y2="6" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    <line x1="8" x2="8" y1="2" y2="6" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    <line x1="3" x2="21" y1="10" y2="10" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    <line x1="12" x2="12" y1="14" y2="18" stroke="#10B981" />
    <line x1="10" x2="14" y1="16" y2="16" stroke="#10B981" />
  </svg>
);

export default CreateCalendarIcon;
